import React from 'react';
import { cn } from '@/lib/utils';

interface TutorialProgressProps {
  currentSlide: number;
  totalSlides: number;
}

const TutorialProgress: React.FC<TutorialProgressProps> = ({ 
  currentSlide, 
  totalSlides 
}) => {
  return (
    <div 
      className="flex justify-center space-x-2"
      role="navigation"
      aria-label="Tutorial progress"
    >
      {Array.from({ length: totalSlides }).map((_, index) => {
        const isActive = index === currentSlide;
        const isPast = index < currentSlide;
        
        return (
          <div
            key={index}
            className={cn(
              'w-3 h-3 rounded-full transition-all duration-300',
              isActive && 'bg-[#e7fe52] scale-125',
              isPast && 'bg-[#ebfe6b]',
              !isActive && !isPast && 'bg-gray-300'
            )}
            role="button"
            aria-label={`Slide ${index + 1} of ${totalSlides}${isActive ? ' (current)' : ''}`}
            aria-current={isActive ? 'step' : undefined}
          />
        );
      })}
    </div>
  );
};

export default TutorialProgress;
